import { GetBtmCarriersQuery } from "./get-btm-carriers-query";
import { BtmCarrier } from "../../model/btm-carrier";

export const GetBtmCarriersHandler = async (query: GetBtmCarriersQuery) => {
    return Promise.resolve(query.warehouseCode === "BLUEBRAND" ? [
        new BtmCarrier("DHL", false),
        new BtmCarrier("GLS", false),
        new BtmCarrier("FedEx", false),
        new BtmCarrier("UPS", false),
        new BtmCarrier("TNT", false),
        new BtmCarrier("DPD", false),
    ] : [
        new BtmCarrier("DHL", false),
        new BtmCarrier("GLS", false),
        new BtmCarrier("FedEx", false),
        new BtmCarrier("UPS", false),
    ]);
};
